export default __webpack_public_path__ + "static/media/journey.d16994ae.svg";